import BookingDetailsPage from './BookingDetailsPage';
import { withBookingDetailsPageContext } from './contextProvider/BookingDetailsPageContextProvider';

const BookingDetailsPageWithContext = withBookingDetailsPageContext(BookingDetailsPage);
const ConnectBookingDetailsPage = () => <BookingDetailsPageWithContext />;

export default ConnectBookingDetailsPage;
